import CategoryForm from "../../../../component/CategoryForm/CategoryForm";
import TreeSelect from "../../../../component/TreeSelect/TreeSelect";
import {listToTree} from "../../../../assets/functions";
import AreaBlockTreeSelect from "../../../Towns/component/AreaBlockTreeSelect/AreaBlockTreeSelect";
import {getUnionAreaObject} from "../../../Towns/functions";
import {TextInputWithoutContainer} from "../../../../component/TextInput/TextInput";
import {SelectWithoutContainer} from "../../../../component/Select/Select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {Fragment, useEffect, useState} from "react";
import {getAllProductCategoriesObject} from "../../functions";
import Loading from "../../../../component/Loading/Loading";

const ProductCategoryForm = ({productCategory, onChange}) => {
    const [isLoading, setIsLoading] = useState(true);
    const pricingMethodOptions = [
        {
            label: "اشتراکی",
            value: "GENERAL",
        },
        {
            label: "اختصاصی",
            value: "SPECIFIC",
        }
    ];
    const userLevels = [
        {
            persianLabel: "عادی",
            englishLabel: "normal",
        }, {
            persianLabel: "نقره ای",
            englishLabel: "silver",
        }, {
            persianLabel: "طلایی",
            englishLabel: "gold",
        },
    ];
    const [allProductCategory, setAllProductCategory] = useState([]);
    const area = {
        isAllIsland: "FALSE",
        includeAreaBlock: [],
        excludeAreaBlock: [],
        includeTown: [],
        excludeTown: [],
    }
    const sending = {
        price: "",
        pricingMethod: "GENERAL",
        userLevel: "",
        deliverMinutes: "",
        area: {...area}
    }

    useEffect(() => {
        (async () => {
            setAllProductCategory(await getAllProductCategoriesObject())
            setIsLoading(false);
        })();

    }, []);

    const changeProductCategory = (key, value) => {
        const newProductCategory = {...productCategory, [key]: value};
        if (key == "sendingStatus" && value == "INHERITED" ){
            newProductCategory.sending = {
                normal: [{...sending}],
                silver: [{...sending}],
                gold: [{...sending}],
            }
        }


        onChange(newProductCategory)
    }

    if (isLoading)
        return <Loading/>

    return (<Fragment>
            <CategoryForm category={productCategory.category} onChange={(value) => {
                changeProductCategory("category", value);
            }}/>
            <TreeSelect mode={"radioSelect"} label={"دسته بندی پدر"}
                        data={listToTree(allProductCategory, [productCategory.parentId])} onChange={(value) => {
                const newParentId = value.length == 1 ? value[0] : "";
                changeProductCategory("parentId", newParentId);
            }}/>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <label className="card-title mb-2">جزییات ارسال</label>
                            <div className="form-switch d-flex justify-content-between">
                                <span>مشابه دسته بندی پدر</span>
                                <input className="form-check-input ms-2" type="checkbox" role="switch"
                                       id="flexSwitchCheckChecked"
                                       checked={productCategory.sendingStatus == "INHERITED"} onChange={() => {
                                    changeProductCategory("sendingStatus", productCategory.sendingStatus == "INHERITED" ? "ALLOCATED" : "INHERITED")
                                }}/>
                                <label className="form-check-label" htmlFor="flexSwitchCheckChecked">تعیین کردن</label>
                            </div>
                        </div>


                        {productCategory.sendingStatus == "ALLOCATED" &&
                            userLevels.map((userLevel, index) => {
                                return (
                                    <div key={index}>
                                        <div className="alert alert-secondary mt-5 text-center">
                                            سطح کاربری {userLevel.persianLabel}
                                        </div>
                                        {
                                            productCategory.sending[userLevel.englishLabel].map((sending, i) => {
                                                return (
                                                    <div key={i} className={"row"}>
                                                        <div className="col-md-4">
                                                            <AreaBlockTreeSelect
                                                                removeArea={getUnionAreaObject(productCategory.sending[userLevel.englishLabel], 0, i)}
                                                                selectedArea={sending.area} label={"انتخاب محدوده"}
                                                                onChange={(value) => {
                                                                    const newArea = {...area};
                                                                    for (let j = 0; j < value.length; j++) {
                                                                        if (i > 0 && value[j] == "ALL_ISLAND") {
                                                                            return;
                                                                        } else if (value[j] == "ALL_ISLAND") {
                                                                            newArea.isAllIsland = "TRUE";
                                                                            newArea.includeAreaBlock = [];
                                                                            newArea.excludeAreaBlock = [];
                                                                            newArea.includeTown = [];
                                                                            newArea.excludeTown = [];
                                                                        } else if (isNaN(value[j])) {
                                                                            //area block
                                                                            newArea.isAllIsland = "FALSE";
                                                                            newArea.includeAreaBlock = [...newArea.includeAreaBlock, value[j]];
                                                                        } else {
                                                                            // town
                                                                            newArea.isAllIsland = "FALSE";
                                                                            newArea.includeTown = [...newArea.includeTown, value[j]];
                                                                        }
                                                                    }
                                                                    const newProductCategorySending = {...productCategory.sending}
                                                                    newProductCategorySending[userLevel.englishLabel][i].area = {...newArea};
                                                                    changeProductCategory("sending", newProductCategorySending);
                                                                }}/>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <TextInputWithoutContainer type={"number"}
                                                                                       classname={"py-2"}
                                                                                       value={sending.price}
                                                                                       onChange={(value) => {
                                                                                           const newProductCategorySending = {...productCategory.sending}
                                                                                           newProductCategorySending[userLevel.englishLabel][i].price = value;
                                                                                           changeProductCategory("sending", newProductCategorySending);
                                                                                       }}
                                                                                       label={"هزینه ارسال"}/>
                                                        </div>


                                                        <div className="col-md-2">
                                                            <SelectWithoutContainer options={pricingMethodOptions}
                                                                                    value={sending.pricingMethod}
                                                                                    onChange={(value) => {
                                                                                        const newProductCategorySending = {...productCategory.sending}
                                                                                        newProductCategorySending[userLevel.englishLabel][i].pricingMethod = value;
                                                                                        changeProductCategory("sending", newProductCategorySending);
                                                                                    }}
                                                                                    label={"نحوه محاسبه"}/>
                                                        </div>


                                                        <div className="col-md-2">
                                                            <TextInputWithoutContainer
                                                                type={"number"}
                                                                classname={"py-2"}
                                                                value={sending.deliverMinutes}
                                                                onChange={(value) => {
                                                                    const newProductCategorySending = {...productCategory.sending}
                                                                    newProductCategorySending[userLevel.englishLabel][i].deliverMinutes = value;
                                                                    changeProductCategory("sending", newProductCategorySending);
                                                                }}
                                                                label={"تحویل (دقیقه)"}/>
                                                        </div>


                                                        <div className="col-1">
                                                            <label
                                                                className="form-label d-block fw-bold text-muted invisible">حذف</label>
                                                            <button className={"btn btn-danger"}
                                                                    onClick={() => {
                                                                        const newProductCategorySending = {...productCategory.sending}
                                                                        const newSending = newProductCategorySending[userLevel.englishLabel].filter((send, ind) => {
                                                                            if (i != ind)
                                                                                return send;
                                                                        });
                                                                        newProductCategorySending[userLevel.englishLabel] = newSending;
                                                                        changeProductCategory("sending", newProductCategorySending);
                                                                    }}
                                                                    type={"button"}>
                                                                <FontAwesomeIcon icon={faTrash}/>
                                                            </button>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                        }
                                        <button type={"button"} className={'btn btn-success w-100'} onClick={() => {
                                            const newProductCategorySending = {...productCategory.sending}
                                            newProductCategorySending[userLevel.englishLabel] = [...newProductCategorySending[userLevel.englishLabel], {...sending}]
                                            changeProductCategory("sending", newProductCategorySending);
                                        }}
                                        >افزودن محدوده
                                        </button>
                                    </div>

                                )

                            })

                        }

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ProductCategoryForm;